/* ── Product art placed by measurement, not by its canvas ──
   Every product PNG is a square canvas, and nothing about that canvas is
   consistent: the toilet-drops bottle is a third of its frame and sits low,
   a bottle-plus-pouch composite nearly fills its own. Worse, the composites
   are not to the same scale as the solo shots (measured 2026-09-21: the
   hand wash bottle is photographed at 4.25 px/mm, its refill bundle at
   2.83), so making two cards' ink the same height makes the same bottle two
   different sizes, which is what Hugo kept seeing.

   So each image is sampled once for two things: the bounds of its opaque
   ink, and the tallest run of DARK pixels in any single column. Real World
   bottles are gloss black on a transparent ground, so that dark column is
   the bottle, in a solo shot and inside a composite alike. A row that
   mixes the product itself (data-art-solo) with composites containing it
   (data-art-composite) is then scaled so that BOTTLE MATCHES BOTTLE, and
   every product stands on one baseline. A row of plain variants carries no
   such marks: those pouches ARE photographed to one scale (3.30 vs 3.29
   px/mm), so they share one scale factor and the 2.5L stays visibly bigger
   than the 1L, which is the truth.

   Reading pixels needs the CDN's CORS header, which Shopify's sends. If it
   is ever missing the canvas is tainted, the read throws, and that image
   simply stays where the CSS put it. */
(function () {
  var boxes = [].slice.call(document.querySelectorAll('.rw-tile__thumb, .rw-byob__prod'));
  if (!boxes.length || !window.HTMLCanvasElement) return;

  function measure(img, done) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var W = probe.naturalWidth, H = probe.naturalHeight;
        /* Bounds do not need full resolution: sample at 300px on the long side. */
        var s = Math.min(1, 300 / Math.max(W, H));
        var w = Math.max(1, Math.round(W * s)), h = Math.max(1, Math.round(H * s));
        var cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        var cx = cv.getContext('2d');
        cx.drawImage(probe, 0, 0, w, h);
        var d = cx.getImageData(0, 0, w, h).data;
        var x0 = w, y0 = h, x1 = -1, y1 = -1;
        var top = new Array(w), bot = new Array(w);
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (d[i + 3] <= 16) continue;
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
            /* 70 of 255: gloss black reads well under it, the sage pouch and
               its printed panel well over it. */
            if (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2] < 70) {
              if (top[x] === undefined) top[x] = y;
              bot[x] = y;
            }
          }
        }
        if (x1 < 0) return done(null);
        /* The tallest single dark column, not the dark bounding box: a box
           would union the bottle with the pouch's dark printed panel and
           report the pouch. A column cannot. */
        var darkH = 0, darkBottom = y1;
        for (var c = 0; c < w; c++) {
          if (top[c] === undefined) continue;
          var ch = bot[c] - top[c] + 1;
          if (ch > darkH) { darkH = ch; darkBottom = bot[c]; }
        }
        done({
          W: W, H: H,
          x: x0 / s, y: y0 / s, w: (x1 - x0 + 1) / s, h: (y1 - y0 + 1) / s,
          darkH: darkH / s, darkBottom: darkBottom / s
        });
      } catch (e) { done(null); }
    };
    probe.onerror = function () { done(null); };
    probe.src = img.currentSrc || img.src;
  }

  function layout(items) {
    if (!items.length) return;
    var solo = null, comps = 0;
    items.forEach(function (f) {
      if (f.solo) solo = solo || f;
      /* A dark column shorter than a third of the ink is not a bottle: it is
         a printed panel or a shadow, and matching on it would be nonsense. */
      if (f.composite && f.ink.darkH > f.ink.h * 0.33) comps += 1;
    });
    var matching = !!solo && comps > 0;

    var target = Infinity, common = Infinity;
    items.forEach(function (f) {
      var bw = f.box.clientWidth, bh = f.box.clientHeight;
      if (!bw || !bh) { f.fit = 0; return; }
      f.fit = Math.min(bw / f.ink.w, bh / f.ink.h);
      /* What each card measures its scale against: the bottle where we can
         see one, the whole ink otherwise. */
      f.ref = (matching && f.composite) ? f.ink.darkH : f.ink.h;
      target = Math.min(target, f.ref * f.fit);
      common = Math.min(common, f.fit);
    });
    if (!isFinite(target) || !isFinite(common)) return;

    items.forEach(function (f) {
      if (!f.fit) return;
      var bw = f.box.clientWidth, bh = f.box.clientHeight;
      var k = matching ? target / f.ref : common;
      /* Everything stands on one line at the foot of the art box. The
         baseline is the bottle's own base in a matched row, clamped so a
         composite whose pouch sits lower than its bottle cannot spill out
         of the box. */
      var base = (matching && f.composite) ? f.ink.darkBottom : f.ink.y + f.ink.h;
      var overhang = Math.max(0, (f.ink.y + f.ink.h - base) * k);
      var st = f.img.style;
      st.setProperty('position', 'absolute', 'important');
      st.setProperty('max-width', 'none', 'important');
      st.setProperty('max-height', 'none', 'important');
      st.setProperty('width', f.ink.W * k + 'px', 'important');
      st.setProperty('height', f.ink.H * k + 'px', 'important');
      st.setProperty('left', (bw / 2 - (f.ink.x + f.ink.w / 2) * k) + 'px', 'important');
      st.setProperty('top', (bh - overhang - base * k) + 'px', 'important');
    });
  }

  /* One group per row of cards, so a row is scaled against itself. Art
     outside a row (the bundle card's product) is its own group. */
  var groups = [], pending = 0;
  boxes.forEach(function (box) {
    var img = box.querySelector('img');
    if (!img) return;
    var tile = box.closest('[data-rw-tile]');
    var gridEl = box.closest('.rw-tiles__grid');
    var group = null;
    for (var i = 0; i < groups.length; i++) {
      if (gridEl && groups[i].el === gridEl) { group = groups[i]; break; }
    }
    if (!group) { group = { el: gridEl, items: [] }; groups.push(group); }
    pending += 1;
    measure(img, function (ink) {
      pending -= 1;
      if (ink) {
        box.style.setProperty('position', 'relative', 'important');
        group.items.push({
          box: box, img: img, ink: ink,
          solo: !!(tile && tile.hasAttribute('data-art-solo')),
          composite: !!(tile && tile.hasAttribute('data-art-composite'))
        });
      }
      if (!pending) groups.forEach(function (g) { layout(g.items); });
    });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      groups.forEach(function (g) { layout(g.items); });
    }, 120);
  });
})();
